<template>
  <div class="container">
    <div class="clearfix">
      <Form @submit.native.prevent :model="formData" label-position="left" class="mytable-titleBox fl">
        <FormItem label="作者名称:" class="fl mytable-title" :label-width="72">
          <Input v-model="formData.username"></Input>
        </FormItem>
        <FormItem label="登录账号:" class="fl mytable-title" :label-width="72">
          <Input v-model="formData.login_name"></Input>
        </FormItem>
      </Form>
      <div class="fl checkReset">
        <Button type="primary" class="fl" @click="handleQuery">查询</Button>
        <Button class="fl" @click="handleReset">重置</Button>
      </div>
      <div class="fl addAuthor">
        <Button type="primary" @click="addAuthor" class="ml32">添加作者</Button>
      </div>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <Page class="mt24" :total="total" :current="page_num" show-elevator show-sizer show-total @on-page-size-change="handleSizeChange" @on-change="handlePageChange"/>
    <!--添加作者-->
    <Modal
      v-model="modalVisibile"
      width="724"
      :mask-closable="false"
      :title="modalTitle"
      @on-cancel="handleCancel"
    >
      <Form @submit.native.prevent ref="modalForm" :model="modalForm" :rules="modalRule" label-position="top">
        <div class="clearfix mb32">
          <FormItem label="作者名称" class="fl" prop="username">
            <Input v-model="modalForm.username" :maxlength="6" class="input294Width" placeholder="请输入作者名称,最多6个字"></Input>
          </FormItem>
          <FormItem label="登录账号" class="fl ml72" prop="login_name">
            <Input placeholder="请输入账号" v-model="modalForm.login_name" class="input294Width"></Input>
          </FormItem>
          <FormItem label="密码" class="fl mt24 " prop="password">
            <Input v-model="modalForm.password" class="input294Width" placeholder="请输入密码"></Input>
          </FormItem>
          <FormItem label="确认密码" class="fl mt24 ml72" prop="confirmPwd">
            <Input v-model="modalForm.confirmPwd" class="input294Width" placeholder="请输入确认密码"></Input>
          </FormItem>
          <FormItem label="排序" class="fl mt24" prop="sort">
            <Input v-model="modalForm.sort" class="input294Width" placeholder="请输入排序号"></Input>
          </FormItem>
          <FormItem label="投中比例" class="fl mt24 ml72" prop="basket">
            <Input v-model="modalForm.basket" :maxlength="7"  class="input294Width" placeholder="请输入投中值,最多7个字"></Input>
          </FormItem>
          <FormItem label="头像" class="fl mt24">
            <img v-if="imgSrc" :src="imgSrc" width="88" height="88" class="img-obj">
            <Upload
              ref="upload"
              :on-success="()=>{}"
              :format="['jpg','jpeg','png']"
              :max-size="2048"
              :before-upload="beforeImgUpload"
              type="drag"
              action=""
              style="display: inline-block;width:88px;">
              <div style="width: 88px;height:88px;line-height: 88px;border: 1px dashed #d9d9d9;">
                <Icon type="ios-camera" size="20"></Icon>
              </div>
            </Upload>
          </FormItem>
          <FormItem label="作者简介" class="fl mt24 ml72" prop="summary">
            <Input v-model="modalForm.summary" class="input294Width" style="width: 500px;" :maxlength="200" type="textarea" placeholder="请输入作者简介,最多200个字"></Input>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit">确定</Button>
      </div>
    </Modal>
    <author-order :id="authorId" :modalTitle="authorModalTitle" ref="authorModal"></author-order>
  </div>

</template>

<script>
import { getCookie } from '../../libs/util'
import mixins from '@/mixins/page'
import * as qiniu from 'qiniu-js'
import authorOrder from '@/components/authorOrder'
export default {
  mixins: [mixins],
  name: 'authorManage',
  components: {
    authorOrder
  },
  data () {
    const validateBasket = (rule, value, callback) => {
      let reg = /\d+/g
      if (value && value.length === 7 && !reg.test(value)) {
        callback(new Error('7个汉字时不能全为中文哦!'))
      } else {
        callback()
      }
    }
    // 校验确认密码是否与密码一致
    const validateConfirmPass = (rule, value, callback) => {
      if (value !== this.modalForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      imgSrc: '',
      authorId: '',
      formData: {

      },
      formData1: {

      },
      modalForm: {
        poster: '',
        username: '',
        login_name: '',
        password: '',
        confirmPwd: '',
        sort: '',
        basket: '',
        summary: ''
      },
      modalForm1: {
        poster: '',
        username: '',
        login_name: '',
        password: '',
        confirmPwd: '',
        sort: '',
        basket: '',
        summary: ''
      },
      authorModalTitle: '',
      tableLoading: false,
      modalTitle: '添加作者',
      modalVisibile: false,
      tableData: [],
      modalLoading: false,
      modalRule: {
        username: [
          { required: true, message: '请输入作者名称', trigger: 'blur' }
        ],
        login_name: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入秘密', trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateConfirmPass, trigger: 'blur' }
        ],
        summary: [
          { required: true, message: '请输入作者简介', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序号', trigger: 'blur' }
        ],
        basket: [
          { required: true, message: '请输入投几中几', trigger: 'blur' },
          { validator: validateBasket, trigger: 'blur' }
        ]
      },
      columns: [
        {
          title: '排序号',
          key: 'sort',
          minWidth: 80
        },
        {
          title: '作者id',
          key: 'id',
          minWidth: 80
        },
        {
          title: '作者名称',
          key: 'username',
          minWidth: 120
        },
        {
          title: '作者头像',
          key: 'poster',
          minWidth: 100,
          render: (h, params) => {
            return h('img', {
              class: {
                table_pic: true
              },
              domProps: {
                src: params.row.poster
              }
            })
          }
        },
        {
          title: '登录账号',
          key: 'login_name',
          minWidth: 150
        },
        {
          title: '密码',
          key: 'pwd',
          minWidth: 120
        },
        {
          title: '作者简介',
          key: 'summary',
          minWidth: 200,
          tooltip: true
        },
        {
          title: '投中比例',
          key: 'basket',
          minWidth: 120
        },

        {
          title: '创建时间',
          key: 'create_time',
          minWidth: 190
        },
        {
          title: '操作',
          minWidth: 170,
          render: (h, params) => {
            return h('div', [
              h('span', {
                class: {
                  btn_edit: true
                },
                on: {
                  click: () => this.handleEdit(params)
                }
              }, '编辑'),
              h('i', {
                class: {
                  sline: true
                }
              }),
              h('span', {
                class: {
                  btn_edit: true
                },
                on: {
                  click: () => this.handleMoney(params)
                }
              }, '盈利'),
              h('i', {
                class: {
                  sline: true
                }
              }),
              h('span', {
                class: {
                  btn_del: true
                },
                on: {
                  click: () => this.handleDel(params)
                }
              }, '删除')
            ])
          }
        }
      ]

    }
  },
  mounted () {
    this.handleQuery()
  },
  methods: {
    // 重置
    handleReset () {
      this.formData = Object.assign({}, this.formData1)
      this.handleQuery()
    },
    // 查询
    handleQuery () {
      this.page_num = 1
      this.getTableData()
    },
    // 获取表格数据
    getTableData () {
      this.tableLoading = true
      let param = { ...this.formData, page_num: this.page_num, page_size: this.page_size }
      this.$api.getAuthorList(param).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.list
          this.tableLoading = false
          this.total = res.data.total_row
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    // 删除
    handleDel (params) {
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('div', {
              class: {
                modal_icon_del: true
              }
            }, '删除作者'),
            h('div', {
              class: {
                modal_text: true
              }
            }, `确定要删除作者${params.row.username}吗?`)
          ])
        },
        onOk: () => {
          this.$api.delAuthor({ user_id: getCookie('userId') - 0, id: params.row.id, username: params.row.username }).then(res => {
            if (res.code === 0) {
              this.$Message.success(res.msg)
              this.handleQuery()
            } else {
              this.$Message.error(res.msg)
            }
          })
        }
      })
    },
    // 图片上传
    beforeImgUpload (file) {
      let that = this
      // 从后台获取token和key
      this.$api.getQiToken({}).then(res => {
        if (res.code === 0) {
          let key = res.data.key
          let token = res.data.QiNiuToken
          let config = {
            useCdnDomain: true,
            region: null
          }
          let putExtra = {
            fname: '',
            params: {},
            mimeType: null
          }
          let observable = qiniu.upload(file, key, token, putExtra, config)
          observable.subscribe({
            error: function (err) {
              this.$Message.success(err)
            },
            complete: function (res) {
              that.modalForm.poster = res.key
              that.$api.getImgPath({ key: res.key }).then(res => {
                if (res.code === 0) {
                  that.imgSrc = res.msg
                }
              })
            }
          })
        } else {
          this.$Message.error(res.msg)
        }
      })
      return false
    },
    handleModalSubmit () {
      this.$refs.modalForm.validate((valid) => {
        if (valid) {
          if (this.modalTitle === '添加作者') {
            this.modalForm.sort = this.modalForm.sort - 0
            this.$api.addAuthor({ ...this.modalForm }).then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg)
                this.modalVisibile = false
                this.handleQuery()
                this.handleCancel()
              } else {
                this.$Message.error(res.msg)
                this.modalForm.sort = this.modalForm.sort + ''
              }
              this.modalLoading = false
            })
          } else {
            this.modalForm.sort = this.modalForm.sort - 0
            this.$api.updateAuthor({ ...this.modalForm }).then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg)
                this.modalVisibile = false
                this.getTableData()
                this.handleCancel()
              } else {
                this.$Message.error(res.msg)
                this.modalForm.sort = this.modalForm.sort + ''
              }
              this.modalLoading = false
            })
          }
        }
      })
    },
    // 弹框取消
    handleCancel () {
      this.$refs.modalForm.resetFields()
      this.modalForm = Object.assign({}, this.modalForm1)
      this.modalVisibile = false
      this.imgSrc = ''
    },
    addAuthor (params) {
      this.modalTitle = '添加作者'
      this.modalVisibile = true
    },
    handleEdit (params) {
      this.modalTitle = '编辑'
      this.modalVisibile = true
      this.modalForm = Object.assign({}, params.row)
      this.modalForm.sort = params.row.sort + ''
      this.imgSrc = params.row.poster
      this.modalForm.confirmPwd = this.modalForm.password = params.row.pwd
    },
    // 查看盈利
    handleMoney (params) {
      this.authorModalTitle = params.row.username + '-订单'
      this.$refs.authorModal.modalVisibile = true
      this.authorId = params.row.id
      this.$nextTick(() => {
        this.$refs.authorModal.handleQuery()
      })
    }
  }
}
</script>

<style scoped lang="less">
  /deep/ .ivu-form-item {
    margin-bottom: 0;
  }

  .checkReset:first-child {
    margin-right: 8px;
  }

  .ivu-modal-footer {
    border-top: none !important;
  }

  .shadowLine {
    width: 660px;
    height: 1px;
    background: #E9E9E9;
    margin: 24px 0;
  }

  .wechartBox {
    width: 282px;
    border: 1px solid #DCE1E6;
    border-radius: 4px;
    line-height: 32px;
    padding-left: 12px;

    span {
      width: 74px;
      text-align: center;
      border-left: 1px solid #DCE1E6;
      cursor: pointer;
    }
  }

  /deep/ .ivu-upload-drag {
    border: none;
    background: transparent;
  }

  /deep/ .textarea.ivu-input {
    min-height: 88px;
    height: 88px;
  }

  .playFont {
    color: #8A9299;
  }

  .boldTitle {
    color: #000;
    font-weight: bold;
    font-size: 14px;
  }

  .graybg {
    width: 724px;
    height: 12px;
    background: #F0F3F5;
    position: relative;
    left: -32px;
    margin-bottom: 24px;
    margin-top: 8px;
  }

  .shadowTitleClick span {
    cursor: pointer;
  }

/deep/ .table_pic{
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: block;
  cursor:pointer;
}
</style>
